import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { PageMain, Eyebrow } from '../Layout/PageLayout';

const ShopSection = styled(PageMain)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: calc(100vh - var(--header-height));
`;

const ComingSoonWrapper = styled(motion.div)`
  max-width: 42rem;
  padding: 2rem;
  border-radius: 18px;
  background: var(--card);
  border: 1px solid var(--glass-border);
  box-shadow: var(--shadow-md);
`;

const ComingSoonText = styled.h2`
  font-family: var(--font-display);
  font-size: clamp(2.5rem, 6vw, 3.5rem);
  font-weight: 700;
  letter-spacing: -0.03em;
  color: var(--text-primary);
  margin-bottom: 1rem;
`;

const SubText = styled.p`
  font-size: 1.08rem;
  color: var(--text-secondary);
  line-height: 1.7;
  max-width: 30rem;
  margin: 0 auto 1.5rem;
`;

const CtaLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.9rem 1.35rem;
  border-radius: 14px;
  background: var(--primary);
  color: var(--primary-foreground);
  font-weight: 700;
  box-shadow: var(--shadow-sm);
  transition: transform var(--transition-base), filter var(--transition-base);

  &:hover {
    transform: translateY(-2px);
    filter: brightness(1.02);
  }
`;

const Shop = () => {
  return (
    <ShopSection>
      <ComingSoonWrapper
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Eyebrow style={{ marginBottom: '0.75rem' }}>Store</Eyebrow>
        <ComingSoonText>Coming soon</ComingSoonText>
        <SubText>
          The shop is being redesigned. Products and downloadable resources will be available here soon.
        </SubText>
        <CtaLink to="/contact">Ask about custom work</CtaLink>
      </ComingSoonWrapper>
    </ShopSection>
  );
};

export default Shop;
